import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const statusTagVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        success: "bg-emerald-500/15 text-emerald-400",
        warning: "bg-amber-500/15 text-amber-400",
        danger: "bg-red-500/15 text-red-400",
        info: "bg-sky-500/15 text-sky-400",
        neutral: "bg-white/10 text-white/70",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  }
)

type StatusTagProps = VariantProps<typeof statusTagVariants> & {
  children: React.ReactNode
  className?: string
}

export function StatusTag({ children, variant, className }: StatusTagProps) {
  return (
    <span className={cn(statusTagVariants({ variant }), className)}>
      {children}
    </span>
  )
}

export function LiveBadge({ label = "Live" }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2 py-0.5 text-xs font-medium text-emerald-400">
      <span className="relative flex size-2">
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex size-2 rounded-full bg-emerald-500" />
      </span>
      {label}
    </span>
  )
}
